// src/components/Layout.js
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import { Outlet } from 'react-router-dom';
import '../css/App.css';
import '../css/Layout.css';
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import LogoutIcon from '@mui/icons-material/Logout';
import Sidebar from '../common/Sidebar';
import HomeIcon from '@mui/icons-material/Home';

const Layout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [screenSize, setScreenSize] = useState(getCurrentDimension());
    const [userDetails, setUserDetails] = useState(getCurrentDimension());

    const [appTitle, setAppTitle] = useState('');
    const [backIconVisible, setBackIconVisible] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const { clearAuth } = useContext(AuthContext);

    const [isOpen, setIsOpen] = useState(false);
    const togglePopover = () => setIsOpen(!isOpen);

    const [isSidebarVisible, setSidebarVisible] = useState(false);
    // const handleMouseEnter = () => setSidebarVisible(true);
    const handleMouseLeave = () => setSidebarVisible(false);
    const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);
    const hideMenus = () => {
        setSidebarVisible(false);
        setIsOpen(false);
    }

    const handleMonthChange = (sMotn) => {
        setSelectedMonth(sMotn);  // Update parent state with the value from child
        
        localStorage.setItem('month', sMotn);
    };

    const handleYearChange = (sYear) => {
        setSelectedYear(sYear);  // Update parent state with the value from child
        localStorage.setItem('year', sYear);
    };

    const handleChildPageClick = (oEvent) => {
        handleMouseLeave();
        setIsOpen(false)
    };
    const handleLogout = (oEvent) => {
        clearAuth();
        navigate("/login");
    };
    const handleHome = (oEvent) => {
        toggleSidebar();
        navigate("/home");
    };
    const handleSearch = () =>{
        toggleSidebar();
        navigate("/noticeList");
    }
    const handleUpload = (oEvent) => {
        toggleSidebar();
        navigate("/upload");
    };
    const onNavBack = () => {
        
        navigate("/home");
    }

    function getCurrentDimension() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }

    useEffect(() => {
        const oData = localStorage.getItem('userInfo');

        const sMonth = localStorage.getItem('month');
        const sYear = localStorage.getItem('year');
        if(sMonth && sMonth != "")
            setSelectedMonth(sMonth);
        if(sYear && sYear != "")
            setSelectedYear(sYear);

        if (oData && oData !== "")
            setUserDetails(JSON.parse(oData));

        switch (true) {
            case location.pathname.includes('/home'):
                setBackIconVisible(false);
                return setAppTitle('Home');
            case location.pathname.includes('/upload'):
                setBackIconVisible(true);
                return setAppTitle('Upload Notice');
            case location.pathname.includes('/noticeDetails'):
                setBackIconVisible(true);
                return setAppTitle('Notice Details');
            case location.pathname.includes('/noticeList'):
                setBackIconVisible(true);
                return setAppTitle('Notice List');
            default:
                setBackIconVisible(true);
                return setAppTitle(location.pathname);
        }

        const updateDimension = () => {
            setScreenSize(getCurrentDimension());
        };
        window.addEventListener("resize", updateDimension);

        return () => {
            window.removeEventListener("resize", updateDimension);
        };
    }, [location]);

    return (
        <div>
            <div id="header">
                <div className="navBarContainer">
                    <div className='divHeaderLeft' style={{ width: '40%' }}>
                        <div className='divHeader1Left' style={{ paddingRight: '10px', paddingLeft: '10px', borderRight: 'solid 1px white' }}>
                            <img src='../advocate_white.png' style={{ width: '1.2rem'}} />
                        </div>
                        <div className='divHeader2Right' style={{ paddingLeft: '10px', color: 'white' }}>
                            <div>
                                <div
                                    className="menu"
                                    onMouseEnter={toggleSidebar}
                                    onClick={toggleSidebar}
                                // onMouseLeave={handleMouseLeave}
                                >
                                    <MenuIcon style={{ fontSize: "200%", cursor: 'pointer' }} />

                                    {/* <label style={{alignItems: 'center', display: 'flex'}}><MenuIcon onClick={toggleSidebar} style={{fontSize: "200%", cursor: 'pointer', width: '.6em', height: 'unset', marginRight: '5px'}}></MenuIcon>Chalke Associates</label> */}

                                </div>
                                <Sidebar isVisible={isSidebarVisible} uploadMenuClick={handleUpload} homeMenuClick={handleHome} searchMenuClick={handleSearch} />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', color: 'white', fontSize: '16px', width: '20%', justifyContent: 'center', alignItems: 'center' }}>
                        {backIconVisible ? <HomeIcon style={{ marginRight: '10px', cursor: 'pointer' }} onClick={onNavBack} /> : ''}{appTitle}
                    </div>
                    <div className='divHeaderRight' style={{ width: '40%' }}>
                        <div className="topnav">
                            {/* <a onClick={handleHome}>Home</a>
                                <a onClick={handleUpload}>Upload</a>
                                <a href="#projects">Reports</a>
                                <a href="#careers">Analytics</a> */}
                        </div>
                        <div style={{color:'white', fontSize: '13px', marginRight: '10px', fontWeight:'bold'}}>
                        Month:
                        </div>
                        <div style={{color:'white', fontSize: '13px', marginRight: '10px'}}>
                        {selectedMonth} {selectedYear}
                        </div>
                        <div className="user-icon-container">
                            <div className="user-icon" style={{ marginRight: '10px' }}>
                                {/* Replace with your user icon, e.g., an SVG or an image */}
                                <span role="img" aria-label="user"><AccountCircleIcon onMouseEnter={togglePopover} onClick={togglePopover} style={{ color: '#fff', cursor: 'pointer' }} /></span>
                            </div>
                            {isOpen && (
                                <div className="popover">
                                    <div className='header'>Welcome!</div>
                                    <ul>
                                        <li><PersonIcon style={{ color: '#002897', width: '1.2rem', marginRight: '5px' }}></PersonIcon><a href="#">{userDetails.name}</a></li>
                                        <li><MarkunreadIcon style={{ color: '#002897', width: '1.2rem', marginRight: '5px' }}></MarkunreadIcon><a href="#">{userDetails.email}</a></li>
                                        <li><LogoutIcon style={{ color: '#002897', width: '1.2rem', marginRight: '5px' }}></LogoutIcon><a onClick={handleLogout}>Logout</a></li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        {/* <div style={{ width: '50px' }}>
                                <AccountCircleIcon onClick={togglePopover} style={{ color: '#fff', cursor: 'pointer' }} />

                            </div> */}
                    </div>
                </div>
            </div>
            <div className="content" onMouseEnter={hideMenus} id="content" onClick={handleChildPageClick} onMouseLeave={handleMouseLeave}>
                <Outlet context={{ MasterMonthChange: handleMonthChange, MasterYearChange: handleYearChange }} />
            </div>
        </div>

    );
};

export default Layout;
